export interface ITalkReaderProps {
  id: string
  fullname: string | null
  organization: string | null
  icon: string | null
  readAt: string | null
}

export default class TalkReaderEntity {
  private _props: ITalkReaderProps

  constructor(props?: ITalkReaderProps | null) {
    this._props = EmptyTalkReaderPropsFactory(props)
  }

  get props(): ITalkReaderProps {
    return this._props
  }

  get clone(): ITalkReaderProps {
    return structuredClone(this._props)
  }

  get id(): string {
    return this._props.id
  }

  get fullname(): string | null {
    return this._props.fullname
  }

  get organization(): string | null {
    return this._props.organization
  }

  get icon(): string | null {
    return this._props.icon
  }

  get readAt(): string | null {
    return this._props.readAt
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyTalkReaderPropsFactory = (props?: Partial<ITalkReaderProps> | null): ITalkReaderProps => ({
  id: '',
  fullname: null,
  organization: null,
  icon: null,
  readAt: null,
  ...props
})
